import { createSlice } from '@reduxjs/toolkit';
 const kgoSlicer = createSlice({
    name: 'kgoSlicer',
    initialState: {
      selectedFairId:0,
      selectedFairName:"",
 
    },
    reducers: {
 
  updateFair: (state, action) => {
      console.log("updateProjectIdAction:"+action.payload.projectid);
        state.selectedFairId= action.payload.selectedFairId;
        state.selectedFairName= action.payload.selectedFairName;
    }
    },
  });
  
  export const {updateFair } = kgoSlicer.actions;
  export const selectedFairId = state => state.reducerKgoPage.selectedFairId;
  export const selectedFairName = state => state.reducerKgoPage.selectedFairName;

 export default kgoSlicer.reducer;